import { Link as JoyLink, LinkTypeMap } from '@mui/joy';
import { Link as ReactRouterLink } from 'react-router-dom';

export type LinkProps = LinkTypeMap['props'] & { to: string; };

export const Link = ({ to, ...props }: LinkProps) => (
  <JoyLink {...props} component={ReactRouterLink} to={to} />
);
